import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { RestService } from 'src/app/services/rest/rest.service';
import { User } from 'src/app/interfaces/user';
import { Session } from 'src/app/interfaces/session';
import { AlertController, ModalController } from '@ionic/angular';
import { PaidBoxComponent } from 'src/app/components/paid-box/paid-box.component';
import { ProductInitialsByID } from 'src/app/data/products';
import { Router } from '@angular/router';
import { SessionSummaryComponent } from 'src/app/components/session-summary/session-summary.component';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-close-session',
  templateUrl: './close-session.page.html',
  styleUrls: ['./close-session.page.scss'],
})
export class CloseSessionPage implements OnInit {
  dateInit: Date;
  dateFin: Date;
  currentPage = 0;
  maxPage = 0;

  users: any[];

  columns = [
    {
      field: 'firstName',
      name: 'EMPLEADO',
      width: 8
    }, {
      field: 'start',
      name: 'Fecha inicio',
      width: 10
    },
    {
      field: 'end',
      name: 'Fecha cierre',
      width: 8
    },
    {
      field: 'number',
      name: 'NÚMERO',
      width: 5
    },
    {
      field: 'isPaid',
      name: 'Pago',
      width: 4,
      type: 'boolean',
      bolValues: {
        true: 'Sí',
        false: 'No'
      }
    },
    {
      field: 'total_money',
      name: 'TOTAL RECAUDADO',
      width: 7
    },
    {
      field: 'un_return',
      name: 'UNIDADES A DEVOLVER',
      width: 10
    },
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 16,
      actions: [
        {
          type: 'view'
        },
        {
          type: 'edit'
        },
        {
          type: 'download'
        },
        {
          type: 'next',
          validate: 'checkend',
          validateType: 'boolean'
        }
      ]
    }
  ];

  lines = [];

  constructor(
    private utils: UtilsService,
    private rest: RestService,
    private sessionService: SessionService,
    private router: Router,
    private alert: AlertController,
    private modal: ModalController
  ) { }

  ngOnInit() { }

  async ionViewWillEnter() {
    await this.getUsers(null);
  }

  async getUsers(records: any) {
    await this.utils.showLoading();
    let result: any;
    if (!records) {
      result = await this.rest.getSessions(this.currentPage, 20);
      this.maxPage = Math.ceil((result.body.total / 20) + ((result.body.total % 20 > 0) ? 1 : 0));
    } else {
      result = records;
    }
    if (result !== false) {
      const sessions = result.body.records;

      this.users = sessions.map(elem => {
        return {
          _id: elem._id,
          firstName: elem.user ? elem.user.firstName : '-',
          lastName: elem.user ? elem.user.lastName : '-',
          username: elem.user ? elem.user.username : '-',
          userId: elem.user ? elem.user._id : '',
          cargas: elem.cargas,
          number: elem.number || '-',
          role: elem.user ? elem.user.role : 'repartidor',
          comment: elem.comment,
          isPaid: elem.isPaid,
          end: elem.end,
          start: elem.start,
          user: elem.user,
          albaranes: (elem.albaranes && elem.albaranes.length > 0) ? elem.albaranes : []
        }
      });
      this.users.forEach((user: User) => {
        if (user.end) {
          const time = new Date(user.end).toLocaleTimeString('es-ES').slice(0, -3);
          user.end = new Date(user.end).toLocaleDateString('es-ES');
          user.end = user.end + ' - ' + time;
          user.checkend = true;
        } else {
          user.end = 'Sesión no cerrada';
          user.checkend = false;
        }
        if (user.start) {
          const time = new Date(user.start).toLocaleTimeString('es-ES').slice(0, -3);
          user.start = new Date(user.start).toLocaleDateString('es-ES');
          user.start = user.start + ' - ' + time;
        }
      });

      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.users.length; i++) {
        const userAlbs = this.users[i].albaranes;
        let userCargas = this.users[i].cargas;

        if (userCargas.length > 0) {
          this.users[i].un_return = '';
          userCargas.forEach(
            (carga, index) => {
              this.users[i].un_return += (carga.furgoneta.units || '') +
                ((index === userCargas.length - 1 || !carga.furgoneta.units) ? '' : ', ');
            }
          );

          userCargas = userCargas.sort((a, b) => b.updatedAt - a.updatedAt);
          userCargas = userCargas[0];
          let auxAlbsUnits = userAlbs.map(elem => elem.unit);
          auxAlbsUnits = auxAlbsUnits.reduce((a, b) => a + b, 0);
        }

        if (userAlbs && userAlbs.length > 0) {
          this.users[i].total_money = 0;
          userAlbs.forEach(
            (albArray, index) => {
              if (albArray && albArray.length > 0 && albArray[0]) {
                const auxMoney = albArray.map(elem => (elem.cliente && elem.cliente.facturaMensual &&
                  elem.cliente.facturaMensual === true) ?
                  (elem.totalWithIva || elem.total) :
                  (elem.total || 0));
                let total: any = 0;
                total = auxMoney.reduce((a, b) => a + b, 0);
                this.users[i].total_money += total;
              }
            }
          );
          this.users[i].total_money = this.utils.parseDecimals(this.users[i].total_money);
        } else {
          this.users[i].un_sell = 0;
          this.users[i].total_money = 0;
        }
      }


      // User.cargas will be empty if no cargas are assigned to him/her
      this.users = this.users.filter((el) => el.role === 'repartidor');
    } else {
      console.log('Error');
      this.utils.showToast('Error cargando usuarios', 'danger');
    }
    await this.utils.hideLoading();
  }

  completeReturnUnits(cargas, albaranes) {
    let result = '';
    cargas.forEach(
      elem => {
        const alb = albaranes.filter(albaran => albaran._id === elem._id);
        if ((!alb || alb.length === 0)) {
          if (elem.unit > 0) {
            result += (elem.unit) + ' ' + ProductInitialsByID(elem._id) + ', ';
          }
        } else {
          const numUnits = (elem.unit - (alb[0].unit ? alb[0].unit : 0));
          if (numUnits > 0) {
            result += numUnits + ' ' + ProductInitialsByID(elem._id) + ', ';
          }
        }
      }
    );
    if (result.length > 0) {
      result = result.slice(0, -2);
    }
    return result;
  }

  groupByUnitsAndProducts(xs, key) {
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x.unit ? x.unit : 0);
      return rv;
    }, {});
  };

  groupByUnitsAndProductsLong(xs, key) {
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push({ total: (x.unit ? x.unit : 0) * x.price });
      return rv;
    }, {});
  };

  ionViewWillLeave() {
    this.dateInit = null;
    this.dateFin = null;
  }

  async clean() {
    if (this.dateFin || this.dateInit) {
      this.dateInit = null;
      this.dateFin = null;
      await this.getUsers(null);
    }
  }

  async search() {
    try {
      let start, end;
      if (this.dateInit) {
        start = new Date(this.dateInit);
        start.setHours(0, 0, 0, 0);
      }
      if (this.dateFin) {
        end = new Date(this.dateFin);
        end.setHours(23, 59, 0, 0);
      }
      if (!start && !end) {
        await this.getUsers(null);
        start = null;
        end = null;
      } else {
        const result: any = await this.rest.getSessions(1, 50, start, end);
        await this.getUsers(result);
        start = null;
        end = null;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async doAction(data) {
    console.log(data);
    const session: Session = data.line;

    if (data.action === 'download') {
      this.sessionService.generateExcel(session);
    }
    if (data.action === 'edit') {
      await this.addComment(session);
    }
    if (data.action === 'view') {
      await this.showMap(session);
    }
    if (((session && !session.end) || (session && ((session.end as any) === 'Sesión no cerrada'))) && data.action === 'next') {
      const notificaciones = await this.getUserAlbaranes(session.user);
      if (!notificaciones || notificaciones === 0) {
        this.closeSessionAlert(session);
      } else {
        const alert = await this.alert.create({
          header: 'Alerta',
          message: 'No puedes cerrar sesión porque el usuario aún tiene cargas sin entregar',
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                this.onlyDeliverCar(session);
              }
            }
          ]
        });

        await alert.present();
      }
    }
    // if (data === 1 || data === -1) {
    //   await this.pagination(data);
    // }
  }

  async getUserAlbaranes(user: any) {
    try {
      let notifications = 0
      console.log(user);
      const resp = await this.rest.getAlbaranesByUserIdWithFilters(user._id, false, false, false, false, true);
      if (resp === false) {
        await this.utils.showToast('Error cargando albaranes', 'danger');
      } else {
        notifications = resp.body.length;
        console.log(resp);
        return notifications;
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error cargando albaranes', 'danger');
    }
  }

  async onlyDeliverCar(session) {
    const alert = await this.alert.create({
      cssClass: 'my-custom-class',
      header: '¿Entregar furgoneta?',
      buttons: [
        {
          text: 'Entregar Furgoneta',
          cssClass: 'secondary',
          handler: async () => {
            const resp: any = await this.rest.getCurrentSessionAlbs(session.userId);
            console.log(resp);
            console.log(session);
            if (resp && resp.body) {
              console.log(resp.body);
              const userCurrentSessionAlbaranes = resp.body;
              const respSummary = await this.rest.getInfoSession(session.cargas, session.userId);
              console.log(respSummary);
              if (respSummary && respSummary.body) {
                const sessionData = respSummary.body.dataSession;
                const summary = respSummary.body.summary;
                // this.cargasUnits = resp.body.cargasUnits;
                // this.userCurrentSessionAlbaranes = resp.body.userCurrentSessionAlbaranes;

                await this.showInfoSummaryModal(session, sessionData, summary, userCurrentSessionAlbaranes, false);
              }
            } else {

            }
          }
        }, {
          text: 'Cancelar',
          cssClass: 'close-button-alert',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }

  async closeSessionAlert(session) {
    const alert = await this.alert.create({
      cssClass: 'my-custom-class',
      header: '¿Quieres cerrar la sesión?',
      buttons: [
        {
          text: 'Entregar Furgoneta',
          cssClass: 'secondary',
          handler: async () => {
            const resp: any = await this.rest.getCurrentSessionAlbs(session.userId);
            console.log(resp);
            console.log(session);
            if (resp && resp.body) {
              console.log(resp.body);
              const userCurrentSessionAlbaranes = resp.body;
              const respSummary = await this.rest.getInfoSession(session.cargas, session.userId);
              console.log(respSummary);
              if (respSummary && respSummary.body) {
                const sessionData = respSummary.body.dataSession;
                const summary = respSummary.body.summary;
                // this.cargasUnits = resp.body.cargasUnits;
                // this.userCurrentSessionAlbaranes = resp.body.userCurrentSessionAlbaranes;

                await this.showInfoSummaryModal(session, sessionData, summary, userCurrentSessionAlbaranes, false);
              }
            } else {

            }
          }
        },
        {
          text: 'Cerrar Sesión',
          handler: async () => {
            const resp: any = await this.rest.getCurrentSessionAlbs(session.userId);
            console.log(resp);
            console.log(session);
            if (resp && resp.body) {
              console.log(resp.body);
              const userCurrentSessionAlbaranes = resp.body;
              const respSummary = await this.rest.getInfoSession(session.cargas, session.userId);
              console.log(respSummary);
              if (respSummary && respSummary.body) {
                const sessionData = respSummary.body.dataSession;
                const summary = respSummary.body.summary;
                // this.cargasUnits = resp.body.cargasUnits;
                // this.userCurrentSessionAlbaranes = resp.body.userCurrentSessionAlbaranes;

                await this.showInfoSummaryModal(session, sessionData, summary, userCurrentSessionAlbaranes, true);
              }
            } else {

            }
          }
        },
        {
          text: 'Cancelar',
          cssClass: 'close-button-alert',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }

  async showInfoSummaryModal(session: any, sessionData: any, summary: any, userCurrentSessionAlbaranes: any, isEndSession = true) {
    const modal = await this.modal.create({
      component: SessionSummaryComponent,
      componentProps: {
        cargas: session.cargas || [],
        sessionData,
        summary,
        currentUser: {
          firstName: session.firstName,
          lastName: session.lastName
        }
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    const newCargas = session.cargas.filter(elem => elem.closed === false).sort((a, b) => b.acceptedAt - a.acceptedAt);
    try {
      if (data && data.confirm) {
        // await this.rest.closeSession(session._id, )
        await this.utils.showLoading();
        if (isEndSession) {
          console.log(userCurrentSessionAlbaranes);
          console.log(summary);
          console.log(session.userId);
          // return;
          await this.rest.closeSession(session._id, userCurrentSessionAlbaranes, summary, session.userId);
          await this.utils.hideLoading();
          await this.utils.showToast('Sesión cerrada correctamente', 'success', 3000);
        } else {

          console.log(newCargas.map(carga => carga._id));
          await this.rest.returnFurgoneta(session._id, (newCargas && newCargas.length > 0)
            ? newCargas.map(carga => carga._id) : [],
            summary,
            userCurrentSessionAlbaranes,
            session.userId);
          await this.utils.hideLoading();
          await this.utils.showToast('Furgoneta entregada correctamente', 'success', 3000);
        }
        this.refreshPage();
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Hubo un error intentando cerrar la sesión', 'danger', 3000);
    }
  }

  async showMap(session: any) {
    this.router.navigate(['/map-details', session._id]);
  }

  async addComment(session: Session) {
    const modal = await this.modal.create({
      component: PaidBoxComponent,
      componentProps: {
        data: {
          isPaid: session.isPaid,
          comment: session.comment
        }
      }
    });
    await modal.present();
    const result = await modal.onWillDismiss();

    if (result && result.data) {
      try {
        await this.utils.showLoading();
        session.isPaid = result.data.isPaid;
        session.comment = result.data.comment;
        session = {
          _id: session._id,
          isPaid: session.isPaid,
          comment: session.comment,
        }
        await this.rest.editSession(session);
        await this.utils.hideLoading();
        this.utils.showToast('Sesión actualizada correctamente', 'success', 3000);
      } catch (error) {
        await this.utils.hideLoading();
        console.log(error);
        this.utils.showToast('Hubo un error actualizando la sesión', 'danger', 3000);
      }
    }
  }
  pagination(event: any) {
    if ((this.currentPage + event >= 0) && (this.currentPage + event <= this.maxPage)) {
      this.currentPage += event;
    }
    this.getUsers(null);
  }

  async refreshPage() {
    await this.getUsers(null);
  }

  async openAlertMonthYear() {
    const alert = await this.alert.create({
      header: 'Elija mes y año',
      inputs: [
        {
          name: 'month',
          type: 'number',
          placeholder: 'Mes',
          value: new Date().getMonth() + 1
        },
        {
          name: 'year',
          type: 'number',
          placeholder: 'Año',
          value: new Date().getFullYear()
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Descargar',
          handler: async (data) => {
            console.log('data');
            console.log(data);
            await this.utils.showLoading();
            await this.getAlbaransByMonth(data.year, data.month);
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  async openAlertYear() {
    const alert = await this.alert.create({
      header: 'Elija el año',
      inputs: [
        {
          name: 'year',
          type: 'number',
          placeholder: 'Año',
          value: new Date().getFullYear()
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Descargar',
          handler: async (data) => {
            console.log('data');
            console.log(data);
            await this.utils.showLoading("Esta operación durará entre 2 y 5 minutos...", 300000);
            await this.getAlbaransByYear(data.year);
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  async getAlbaransByMonth(year, month) {
    const result: any = await this.rest.getSessionByMonth(year, month);
    if (result && result.body && result.body) {
      const records = result.body;
      this.sessionService.createMonthSession(records.records, year, month);
    }
  }

  async getAlbaransByYear(year) {
    let result: any[] = []; 

    for(let i = 1; i <= 12; i++){
        let aux: any = await this.rest.getSessionByMonth(year, i);
        result.push(...aux.body.records); 
    }

    if (result) {
        this.sessionService.createYearSession(result, year);
    }
}

}
